"use client"

import { createContext, useContext, useEffect, useState } from "react"
import { useUIStore } from "@/lib/stores/useUIStore"

type Theme = "dark" | "light" | "system"

type ThemeProviderProps = {
  children: React.ReactNode
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const { theme } = useUIStore()
  const [mounted, setMounted] = useState(false)

  // Avoid hydration mismatch by only mounting after client-side render
  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    const root = window.document.documentElement
    
    root.classList.remove("light", "dark")
    
    if (theme === "system") {
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light"
      root.classList.add(systemTheme)
      return
    }
    
    root.classList.add(theme)
  }, [theme])

  if (!mounted) {
    return <>{children}</>
  }

  return <>{children}</>
} 